'use client';

import { Sun, Moon } from 'lucide-react';
import { useTheme } from './ThemeProvider';

interface ThemeToggleProps {
  className?: string;
  /** Labels are supplied by the caller so this stays translatable via the
   *  page's own dictionary instead of hardcoding English here. */
  lightLabel?: string;
  darkLabel?: string;
}

export default function ThemeToggle({
  className = '',
  lightLabel = 'Switch to light mode',
  darkLabel = 'Switch to dark mode',
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? lightLabel : darkLabel}
      title={isDark ? lightLabel : darkLabel}
      className={`relative inline-flex items-center justify-center p-1.5 rounded-lg text-textSecondary hover:text-foreground hover:bg-cardBg transition-colors ${className}`}
    >
      <Sun className={`h-[18px] w-[18px] transition-all duration-200 ${isDark ? 'scale-0 -rotate-90 absolute' : 'scale-100 rotate-0'}`} />
      <Moon className={`h-[18px] w-[18px] transition-all duration-200 ${isDark ? 'scale-100 rotate-0' : 'scale-0 rotate-90 absolute'}`} />
    </button>
  );
}
